import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class ReasonOfAllowanceInsertService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  insertCompanyType(token, reasonOfAllowance: any) {
  	return this.http
  	.post(this.apiUrl + "motivoabono/v1/inserirmotivoabono", reasonOfAllowance, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  	.map((res: Response) => res.json())
  	.catch(e => {
  		if (e.status === 401) {
  			return Observable.throw('Unauthorized');
  		}
  	});
  }

}



// WEBPACK FOOTER //
// ./src/app/reason-of-allowance/service/reason-of-allowance-insert/reason-of-allowance-insert.service.ts